export default __webpack_public_path__ + "static/media/spring-boot.9a4c2490.svg";